import AddRouteMap from "./_components/AddRouteMap";

export default function AddRoute() {
  return (
    <div className="px-4 space-y-6">
      <AddRouteMap />
    </div>
  );
}
